<template lang="pug">
.units__installations
  .units__installations__bar
    .units__installations__name {{ installationName }}
    .units__installations__action(@click="addScene(installationID)")
        van-icon(name="more")

  van-cell-group(v-if="listScenes")
    //- Listado de usuarios por instalación
    Draggable(
      handle=".handle"
      animation="200"
      ghostClass="ghost"
      :list="listScenes"
      @end="orderScene"
      @start="drag = true")
      transition-group(type="transition" :name="!drag ? 'flip-list' : null")
        van-cell.scene.draggable(
          v-for="sceneID in listScenes"
          :id="sceneID"
          :key="sceneID"
          :title="scenes[sceneID].name"
          @click="launchScene(installationID, sceneID)"
          is-link)
          template(slot="icon")
            van-icon.handle(name="menu" v-if="order")
            van-icon.scene__icon(:name="`scene-${scenes[sceneID].icon}`")

          template(slot="right-icon")
            van-icon(name="video" @click.stop="launchScene(installationID, sceneID)")
            van-icon(name="right" @click.stop="updateScene(installationID, scenes[sceneID])")

</template>

<script>
import Draggable from 'vuedraggable';
import SceneService from '@/services/scene.service';
import { getErrorId } from '@/services/error.service';
import { mapGetters, mapActions } from 'vuex';
import { CONFIG } from '@/app.config';

export default {
  components: { Draggable },
  props: {
    installationID: {
      type: String,
      required: true,
    },

    installationName: {
      type: String,
      required: true,
    },

    scenes: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      sceneError: null,
      drag: false,
      order: CONFIG.ORDER,
    };
  },
  computed: {
    ...mapGetters({
      getScenesOrder: 'unitsModule/getScenesOrder',
    }),

    /**
     * Devuelve los datos de la instalación almacenados en el Store
     *
     * @return {Installation} - Datos del dispositivo
     */
    listScenes: {
      get() {
        return this.getScenesOrder(this.installationID);
      },
      set(newListScenes) {
        this.updateScenesOrder(this.installationID, newListScenes);
      },
    },
  },

  methods: {
    ...mapActions({
      updateScenesOrder: 'unitsModule/updateScenesOrder',
    }),

    async orderScene(event) {
      try {
        // Inicializo valores
        this.sceneError = null;
        this.drag = false;

        const data = {
          installationID: this.installationID,
          sceneID: event.item.id,
          scene: {
            position: event.newIndex,
          },
        };

        // Realizo la petición
        await SceneService.editScene(data);
      } catch (error) {
        // Obtengo el error
        this.sceneError = getErrorId(error);
        this.$toast.fail({ mask: true, message: this.$i18n.t('general.errors.default.title') });
      }
    },

    async launchScene(installationID, sceneID) {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.sceneError = null;

        const data = { installationID, sceneID };

        // Realizo la petición
        await SceneService.launchScene(data);

        this.$toast.clear();
        this.$toast.success({ mask: true, message: this.$i18n.t('scene.launchSuccess') });
      } catch (error) {
        // Obtengo el error
        this.sceneError = getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('general.errors.default.title') });
      } finally {
        this.isLoading = false;
      }
    },

    updateScene(installationID, scene) {
      this.$emit('updateScene', { installationID, scene });
    },

    addScene(installationID) {
      this.$emit('addScene', { installationID });
    },
  },
};
</script>
